const k = 1.856593992;

export const calcDistance = (from, to) => {
    const a = from.Laengde_grader + from.Laengde_min / 60 + from.Laengde_sek / 3600 + from.Laengde_100_dele_sek / 360000;
    const b = to.Laengde_grader + to.Laengde_min / 60 + to.Laengde_sek / 3600 + to.Laengde_100_dele_sek / 360000;
    const c = from.Bredde_grader + from.Bredde_min / 60 + from.Bredde_sek / 3600 + from.Bredde_100_dele_sek / 360000;
    const d = to.Bredde_grader + to.Bredde_min / 60 + to.Bredde_sek / 3600 + to.Bredde_100_dele_sek / 360000;
    const a1 = a * (Math.PI / 180);
    const b1 = b * (Math.PI / 180);
    const c1 = c * (Math.PI / 180);
    const d1 = d * (Math.PI / 180);
    const s1 = Math.sin(c1) * Math.sin(d1);
    const s2 = Math.cos(c1) * Math.cos(d1) * Math.cos(a1 - b1);
    const s3 = s1 + s2;
    const s4 = -Math.atan(s3 / Math.sqrt(1 - Math.pow(s3, 2))) + (Math.PI / 2);
    const s5 = s4 * (180 / Math.PI);
    return Math.round(1000 * (s5 * 60) * k) / 1000;
};

// Parameters:
// distance: float
// releaseDate: date
// releaseTime: string, HH:MM
// homeDay: integer
// homeTime: date/time, ignore date part
// nightStart: integer (number of minutes to sunrise)
// nightEnd: integer (number of minutes to sunset)
// watchStartDate: date
// watchStartTime: string, HH:MM:SS
// watchControlDate: date
// watchControlTime: string, HH:MM:SS
// watchError: float
export const calcMpm = (distance, releaseDate, releaseTime, homeDay, homeTime, nightStart, nightEnd, watchStartDate, watchStartTime, watchControlDate, watchControlTime, watchError) => {
    // Initialize and validate.
    const result = {
        duration: null,
        mpm: null,
        correctedHomeTime: null,
        msg: null,
        status: -1,
    };
    if (homeDay === null || homeTime === null) return result;
    if (distance === null) {
        result.status = 6;
        result.msg = 'Afstand ikke fundet.';
        return result;
    }
    if (releaseDate === null || releaseTime === null) {
        result.status = 1;
        result.msg = 'Der er ikke angivet sliptid eller slipdato.';
        return result;
    }
    if (watchStartDate === null || watchStartTime === null || watchControlDate === null || watchControlTime === null || watchError === null) {
        result.status = 2;
        result.msg = 'Der mangler uroplysninger for slag.';
        return result;
    }

    // Calculate corrected home.
    let h1 = Number(watchStartTime.substr(0, 2));
    let m1 = Number(watchStartTime.substr(3, 2));
    let s1 = Number(watchStartTime.substr(6, 2));
    let h2 = homeTime.getHours();
    let m2 = homeTime.getMinutes();
    let s2 = homeTime.getSeconds();
    let homeSecond = 3600 * h2 + 60 * m2 + s2;
    let duration = homeSecond - 3600 * h1 - 60 * m1 - s1 + (releaseDate.getTime() - watchStartDate.getTime()) / 1000 + homeDay - 1;
    if (duration < 0) {
        result.status = 3;
        result.msg = 'Hjemkomst ligger før urstart.';
        return result;
    }
    h1 = Number(watchControlTime.substr(0, 2));
    m1 = Number(watchControlTime.substr(3, 2));
    s1 = Number(watchControlTime.substr(6, 2));
    if (3600 * h1 + 60 * m1 + s1 - homeSecond + (watchControlDate.getTime() - releaseDate.getTime()) / 1000 - homeDay + 1 < 0) {
        result.status = 4;
        result.msg = 'Hjemkomst efter kontrol - Tjek om radiouret er fanget efter duestempling.';
        return result;
    }
    let correction = duration * watchError;
    let homeSecond2 = homeSecond + correction;
    homeSecond = homeSecond + Math.round(correction);
    if (homeSecond < 0) homeSecond = 0;
    else if (homeSecond >= 86400) homeSecond = 86399;
    s2 = homeSecond % 60;
    let rest = (homeSecond - s2) / 60;
    m2 = rest % 60;
    h2 = (rest - m2) / 60;
    result.correctedHomeTime = String(h2).padStart(2, '0') + ':' + String(m2).padStart(2, '0') + ':' + String(s2).padStart(2, '0');

    // Correct for night time.
    h1 = Number(releaseTime.substr(0, 2));
    m1 = Number(releaseTime.substr(3, 2));
    if (homeSecond2 > nightStart * 60) homeSecond2 = nightStart * 60;
    else if (homeSecond2 < nightEnd * 60) homeSecond2 = nightEnd * 60;
    let nightDuration = 60 * (1440 - nightStart + nightEnd);
    duration = homeSecond2 - 3600 * h1 - 60 * m1 + (86400 - nightDuration) * (homeDay - 1);
    if (duration <= 0) {
        result.status = 5;
        result.msg = 'Hjemkomst ligger før sliptid. Check sliptid og -dato.';
        return result;
    }
    s1 = Math.round(duration) % 60;
    rest = (Math.round(duration) - s1) / 60;
    m1 = rest % 60;
    h1 = (rest - m1) / 60;
    result.duration = String(h1).padStart(2, '0') + ':' + String(m1).padStart(2, '0') + ':' + String(s1).padStart(2, '0');

    // Calculate speed.
    result.mpm = 60 * distance * 1000 / duration;
    return result;
};


// WEBPACK FOOTER //
// ./src/common/src/util/raceUtil.js